import { d as e } from "./index795.mjs";
import { f as r } from "./index758.mjs";
import { d as t } from "./index844.mjs";
var a = e, i = r, o = t, s = !a && !i(function() {
  return Object.defineProperty(o("div"), "a", {
    get: function() {
      return 7;
    }
  }).a !== 7;
});
export {
  s as i
};
